import styled from '@emotion/styled';
import { Button, tokens } from '@hotjar/hotsauce';
import { GuideCard } from '@hotjar/activation-toolkit';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';
import { useTranslation } from '@hotjar/translations';
import { useAddToDemoSite } from '@hotjar/webapp/domains/activation/product-tour/useAddToDemoSite';
import { useGuideCardVisibility } from '@hotjar/webapp/hooks/useGuideCardVisibility';
import ImgDemo from './assets/img-guide-card.png';

const Img = styled.div`
  width: 100%;
  height: 100%;
  background-image: url('${ImgDemo}');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  background-color: ${tokens.color.blossom_300};
`;

const Wrapper = styled.div`
  grid-column: span 2;
`;

export const ProductTourGuideCard = (): JSX.Element | null => {
  const { t } = useTranslation();
  const { isLoading: isAddToDemoSiteLoading, addToDemoSite } = useAddToDemoSite();
  const { isGuideCardVisible, dismissGuideCard } = useGuideCardVisibility('product-tour');
  const { click: trackClick } = useTrack();
  const handleOnClick = async () => {
    trackClick('CTA', 'Product-tour guide-card', {});
    addToDemoSite();
  };
  const handleOnDismiss = () => {
    trackClick('dismiss', 'Product-tour guide-card', {});
    dismissGuideCard();
  };

  return isGuideCardVisible ? (
    <Wrapper>
      <GuideCard
        label={t('activation:space-overview.product-tour.guide-card.label')}
        title={t('activation:space-overview.product-tour.guide-card.title')}
        description={t('activation:space-overview.product-tour.guide-card.description')}
        media={<Img />}
        onDismiss={handleOnDismiss}
        actions={
          <div>
            <Button
              isLoading={isAddToDemoSiteLoading}
              loadingText={t(`activation:space-overview.product-tour.loading-demo-site`)}
              onClick={handleOnClick}
              kind="secondary"
            >
              {t('activation:space-overview.product-tour.guide-card.cta')}
            </Button>
          </div>
        }
      />
    </Wrapper>
  ) : null;
};
